"use client";

import YoutubeVideo from "@components/youtube-video";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@repo/ui/components/ui/carousel";

export default function Tutorial() {
  const YTid = ["aG4YS9gWXgc", "LuC9tG5xR6c", "yiK1uRjE6Y4", "3wpp7yvdr7s"];

  return (
    <div className="flex justify-center w-full mt-10">
      <div className="w-full max-w-4xl">
        <Carousel autoplay={false} navigation={true} className="w-full">
          <CarouselContent>
            {YTid.map((id: string, idx: number) => (
              <CarouselItem key={idx}>
                <YoutubeVideo YTid={id} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  );
}
